export default [
	{
		target: '#menu',
		content: 'This is the "side menu". Here you can open, create, import or export Stream Apps.'
	},
	{
		target: '#dashboard-stream-apps',
		content: 'The main menu of Streamsheets consists of two tabs. On the left, you find an overview of all your Stream Apps.'
	},
	{
		target: '#dashboard-streams',
		content: 'On the right, you find an overview of all your Streams.'
	},
	{
		target: '#dashboard-button-view',
		content: 'Click here to switch between grid and list view.'
	},
	{
		target: '#add',
		content: 'To add a new App or Stream, click this "Add" Icon and start building.'
	}
];



// WEBPACK FOOTER //
// ./src/tutorial/dashboard-steps.js